<template>
  <div>
    <div v-if="detailsLoading" v-loading="detailsLoading" class="order-details" style="width: 930px;height: 750px;"></div>
    <div class="infoTop">
      <div class="itLeft">
        <gt-coverImg :img-class="'liOne_img'" :img-url="detailsData.vipCardImgUrl" :default-img="'static/images/card_bg.png'"></gt-coverImg>
      </div>
      <div class="itRight">
        <p>套餐名称：{{ detailsData.vipCardName }}</p>
        <p>
          套餐类型：{{ detailsData.countLimitType == 1 ? '有限次数' : detailsData.countLimitType == 2 ? '无限次数' : '通用次数' }}<label>{{ detailsData.countLimitType == 3 ? ('（'+detailsData.universalCount+'次）') : '' }}</label>
        </p>
      </div>
      <div class="itRight">
        <p>套餐金额：<del>￥{{ (detailsData.itemsPrice*1+detailsData.productsPrice*1).toFixed(2) }}</del><span>￥{{ detailsData.price }}</span></p>
        <p>可用门店：共{{ detailsData.useStoreList ? detailsData.useStoreList.length : 0 }}个门店<el-popover placement="right" trigger="click"><div v-for="(v,n) in detailsData.useStoreList" :key="n" style="padding: 3px 12px;">{{ v.name }}</div><samp slot="reference">查看全部</samp></el-popover></p>
      </div>
      <div class="itRight">
        <p>购买时间：{{ detailsData.createTime }}</p>
        <div class="dueTiem">
          <label>到期时间：</label>
          <span>{{ detailsData.validType == 2 ? '永久有效' : detailsData.pastTime }}<el-popover v-if="Lib.getPackageTime() && detailsData.isElectronicTicket != 1" ref="popover5" placement="bottom" trigger="click">
            <div style="padding: 20px;">
              <el-date-picker v-model="dueDate" type="date" style="margin-right: 10px;" placeholder="选择日期" :clearable="false" value-format="yyyy-MM-dd" :picker-options="{disabledDate:disabledDate}"></el-date-picker>
              <el-button type="primary" class="button" @click="modifyDueTiem(1,detailsData)">确定</el-button>
            </div>
            <el-button slot="reference" type="text" style="padding-left: 10px;" @click="modifyDueTiem(0,detailsData)">修改</el-button>
          </el-popover></span>
        </div>
      </div>
    </div>
    <el-tabs v-model="diaTabs" type="card">
      <el-tab-pane label="项目信息" name="first">
        <div v-if="detailsLoading == false" class="details_content">
          <div v-if="(detailsData.clientVipCardItemInfoList ? detailsData.clientVipCardItemInfoList.length > 0 ? true : false :false) && (detailsData.vipCardItemInfoDto ? detailsData.vipCardItemInfoDto.length > 0 ? true : false : false)" class="details_top"><span></span>项目信息</div>
          <!--已拥有-项目-->
          <div v-if="detailsData.clientVipCardItemInfoList" class="details_mg deduction">
            <div v-if="detailsData.clientVipCardItemInfoList.length > 0">
              <el-table ref="multipleTableI" :data="detailsData.clientVipCardItemInfoList" tooltip-effect="light" style="width: 100%" row-key="id" :expand-row-keys="openListKey" @selection-change="projectSelectionChange(detailsData.clientVipCardItemInfoList,$event,1)">
                <el-table-column v-if="status != 2" type="selection" :selectable="checkTableSelectionOne" width="55"></el-table-column>
                <el-table-column v-if="status != 2" type="expand" width="20">
                  <template slot-scope="props">
                    <div class="tableExpandList">
                      <div v-for="(v,n) in props.row.chooseList" :key="n" class="li">
                        <div class="tableExpand">{{ v.dictItemName }}</div>
                        <div v-if="v.isDisabled">
                          <div v-if="v.percentage4ServeList.length > 0 && v.isPercentage == 1 && v.residueCount">
                            <el-tooltip class="item" effect="light" placement="right-start">
                              <div slot="content">
                                <p v-for="(items,indexs) in v.percentage4ServeList" :key="indexs" style="padding: 0 10px 0 0;">
                                  <span>
                                    {{ items.technicianName }}：({{ items.percentage }}{{ items.percentageType == 1 ? '元' : '%' }})
                                  </span>
                                </p>
                              </div>
                              <el-button type="text" class="btnChoose" @click="chooseStaff(props.$index,n)">
                                <span v-for="(items,indexs) in v.percentage4ServeList" :key="indexs" style="padding: 0 10px 0 0;">{{ items.technicianName }}</span>
                              </el-button>
                            </el-tooltip>
                          </div>
                          <el-tooltip v-else-if="v.isPercentage == 0 || !v.residueCount || !v.isDisabled" class="item" effect="light" :content="'该服务暂无关联'+Lib.collectively()" placement="bottom">
                            <yz-btn size="mini" type="forbidden">选择</yz-btn>
                          </el-tooltip>
                          <yz-btn v-else size="mini" type="primary" @click="chooseStaff(props.$index,n)">选择</yz-btn>
                        </div>
                        <yz-btn v-else size="mini" type="forbidden">选择</yz-btn>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="dictItemName" label="项目名称" width="250">
                  <template slot-scope="scope">
                    <el-popover v-if="(scope.row.status == -1) || (scope.row.status == -2)" placement="bottom-start" trigger="hover">
                      <p style="padding: 10px;">{{ scope.row.status == -1 ? '该项目已删除' : '该项目已下架' }}</p>
                      <samp v-if="scope.row.status == -1" slot="reference" class="icon_sc">删</samp>
                      <samp v-if="scope.row.status == -2" slot="reference" class="icon_xj">下</samp>
                    </el-popover>
                    <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                      <div slot="content">
                        <p>{{ scope.row.dictItemName }}</p>
                      </div>
                      <span class="commonTableShow" :style="((scope.row.status == -1) || (scope.row.status == -2)) ? 'width: 205px;' : 'width: 225px;'" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.dictItemName }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="dictTypeName" label="所属项目" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="detailsData.countLimitType!=3" prop="residueCount" label="剩余次数/总共次数" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <samp class="themeFC">{{ detailsData.countLimitType == 1 ? scope.row.residueCount :detailsData.countLimitType == 2 ? '无限' : '' }}</samp>/{{ detailsData.countLimitType == 1 ? (scope.row.residueCount*1 + scope.row.expenseCount*1).toFixed(0) : detailsData.countLimitType == 2 ? '无限' : '' }}
                  </template>
                </el-table-column>
                <el-table-column v-if="status != 2" prop="count" label="扣除次数" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-input-number v-if="detailsData.countLimitType==1" v-model.trim="scope.row.count" class="btnOne" size="mini" :min="scope.row.residueCount ? 1 : 0" :max="scope.row.residueCount > 99 ? 99 : scope.row.residueCount" :disabled="!scope.row.isDisabled ? true : scope.row.residueCount < 1 ? true : scope.row.residueCount == 1 ? true : false" @change="countChange(scope.row,scope.$index,3)"></el-input-number>
                    <el-input-number v-else-if="detailsData.countLimitType==2" v-model.trim="scope.row.count" class="btnOne" size="mini" :min="scope.row.residueCount ? 1 : 0" :max="99" :disabled="!scope.row.isDisabled ? true:false" @change="countChange(scope.row,scope.$index,3)"></el-input-number>
                    <el-input-number v-else v-model.trim="scope.row.count" class="btnOne" size="mini" :min="1" :max="(detailsData.beUsedCount > NumOf) ? (detailsData.beUsedCount > 99 ? 99 : detailsData.beUsedCount) : (scope.row.count > 99 ? 99 : scope.row.count)" :disabled="!scope.row.isDisabled ? true :false" @change="countChange(scope.row,scope.$index,3)"></el-input-number>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-if="(detailsData.clientPackageProductList ? detailsData.clientPackageProductList.length > 0 ? true : false : false) && (detailsData.basePackageProductList ? detailsData.basePackageProductList.length > 0 ? true : false : false)" class="details_top"><span></span>产品信息</div>
          <!--已拥有-产品-->
          <div v-if="detailsData.clientPackageProductList" class="deduction">
            <div v-if="detailsData.clientPackageProductList.length > 0">
              <el-table ref="multipleTableP" :data="detailsData.clientPackageProductList" tooltip-effect="light" style="width: 100%" @selection-change="projectSelectionChange(detailsData.clientPackageProductList,$event,2)">
                <el-table-column v-if="status != 2" type="selection" :selectable="checkTableSelectionTwo" width="75"></el-table-column>
                <el-table-column prop="productName" label="产品名称" width="250">
                  <template slot-scope="scope">
                    <el-popover v-if="scope.row.isStock == 1 ? false : true" placement="bottom-start" trigger="hover">
                      <p style="padding: 10px;">该产品无库存</p>
                      <samp slot="reference" class="btwo" style="margin: -6px;">无</samp>
                    </el-popover>
                    <el-popover v-if="scope.row.isStock == 1 ? scope.row.isWarning == 1 ? true : false : false" placement="bottom-start" trigger="hover">
                      <p style="padding: 10px;">该产品库存预警</p>
                      <samp slot="reference" class="bone" style="margin: -6px;"><i class="iconfont">&#xe628;</i></samp>
                    </el-popover>
                    <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                      <div slot="content">
                        <p>{{ scope.row.productName }}</p>
                      </div>
                      <span class="commonTableShow" style="width: 155px;" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.productName }}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="specification" label="产品规格" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="detailsData.countLimitType!=3" prop="residueCount" label="剩余次数/总共次数" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <samp class="themeFC">{{ detailsData.countLimitType == 1 ? scope.row.residueCount :detailsData.countLimitType == 2 ? '无限' : '' }}</samp>/{{ detailsData.countLimitType == 1 ? (scope.row.residueCount*1 + scope.row.expenseCount*1).toFixed(0) : detailsData.countLimitType == 2 ? '无限' : '' }}
                  </template>
                </el-table-column>
                <el-table-column v-if="status != 2" label="划扣数量" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-input-number v-if="detailsData.countLimitType==1" v-model.trim="scope.row.count" class="btnOne" size="mini" :min="scope.row.residueCount ? 1 : 0" :max="scope.row.residueCount" :disabled="!scope.row.isDisabled ? true : scope.row.residueCount < 1 ? true : scope.row.residueCount == 1 ? true : false" @change="countChange('','' ,3)"></el-input-number>
                    <el-input-number v-else-if="detailsData.countLimitType==2" v-model.trim="scope.row.count" class="btnOne" size="mini" :min="scope.row.residueCount ? 1 : 0" :max="99" :disabled="!scope.row.isDisabled ? true : false" @change="countChange('','',3)"></el-input-number>
                    <el-input-number v-else v-model.trim="scope.row.count" class="btnOne" size="mini" :min="1" :max="(NumOf < detailsData.beUsedCount)?detailsData.beUsedCount :scope.row.count" :disabled="!scope.row.isDisabled ? true : false" @change="countChange('','' ,3)"></el-input-number>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div style="line-height: 20px;text-align: right;position: relative;top: 10px;">{{ getChooseHkInfo() }}</div>
        <span v-show="searchBeforePhone && detailsLoading == false && status != 2" class="dialog-footer">
          <span v-if="detailsData.countLimitType===3" class="dialog-number">剩余通用次数：<span class="detail_text">{{ searchBeforePhone&&timeRemindX(detailsData.type,detailsData.validType,detailsData.pastTime,detailsData.cardStatus) ?detailsData.beUsedCount :detailsData.universalCount }}</span>次</span>
          <el-button v-if="((detailsData.clientPackageProductList ? detailsData.clientPackageProductList.length > 0 ? true : false : false) || (detailsData.clientVipCardItemInfoList ? detailsData.clientVipCardItemInfoList.length > 0 ? true : false : false)) && detailsData.type != 3" style="margin: 20px 0px 0px 20px;float: right;" size="medium" type="primary" :disabled="((chooseServiceList.length > 0 || chooseProductList.length > 0) && !buckleBtn) ? false : true" @click="chooseServiceList.length > 0 || chooseProductList.length > 0 ? buckle(detailsData) : ''">划扣</el-button>
          <el-button v-if="detailsData.isElectronicTicket != 1 && detailsData.cardStatus == 0" style="margin: 20px 0px 0px 20px;float: right;" size="medium" @click="recharge(detailsData)">续购</el-button>
        </span>
      </el-tab-pane>
      <el-tab-pane label="划扣记录" name="second">
        <el-table :data="detailsData.vipCardUseMsgDTOList">
          <el-table-column prop="orderCode" label="订单号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="dateTime" label="划扣时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="划扣项目" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <p v-for="(v,n) in scope.row.itemMsgDTOList" :key="n" class="ellipsis">{{ v.itemName }}</p>
            </template>
          </el-table-column>
          <el-table-column label="划扣次数">
            <template slot-scope="scope">
              <p v-for="(v,n) in scope.row.itemMsgDTOList" :key="n">{{ v.count }}</p>
            </template>
          </el-table-column>
          <el-table-column label="技师">
            <template slot-scope="scope">
              <p v-for="(v,n) in scope.row.itemMsgDTOList" :key="n" class="ellipsis">{{ v.technicianName || '--' }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作员工" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.dutyName || '--' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="购买记录" name="third">
        <el-table :data="detailsData.vipCardBuyOrderList">
          <el-table-column prop="orderCode" label="订单号"></el-table-column>
          <el-table-column prop="createTime" label="购买时间"></el-table-column>
          <el-table-column prop="shopName" label="购买门店"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="seeOrder(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="修改记录" name="fourth">
        <el-table :data="detailsData.packagePastTimeDTOList">
          <el-table-column prop="createTime" label="修改时间"></el-table-column>
          <el-table-column prop="technicianName" label="操作员工"></el-table-column>
          <el-table-column label="修改内容">
            <template slot-scope="scope">
              <span>将到期时间{{ scope.row.oldPastTime }}修改为{{ scope.row.newPastTime }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="提示" class="newPackageDia" :visible.sync="buckleDiglog" width="420px" :append-to-body="true">
      <div class="info">
        <h1>
          <i class="el-icon-circle-check"></i>
        </h1>
        <h6>划扣成功</h6>
        <h5 v-if="isDesktop===0||ishd==0">
          <i :class="refreshStatus ? 'el-icon-loading' : 'el-icon-refresh'" @click="getPrinterList"></i>
          <span>当前打印机设备号：</span>
          <el-dropdown v-if="printerId || printerName" trigger="click" @command="choosePrinter">
            <span class="el-dropdown-link">
              {{ printerName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu v-if="printerList.length > 0" slot="dropdown" size="medium" @click="choosePrinter">
              <el-dropdown-item v-for="(v,n) in printerList" :key="n" :command="v.id+','+v.printerName" :disabled="v.printerState == 0 ? true : false">{{ v.printerName }}{{ v.printerState == 0 ? '（不在线）' : '' }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <label v-else>
            <span class="theme-red">未连接</span>
            <span class="theme-blue" @click="jumpSetPrinter">前往设置</span>
          </label>
        </h5>
        <h4 v-if="printerId" @click="printOrder(1)">
          <span>打印小票</span>
        </h4>
        <h3 @click="buckleDiglog = false">
          <span>取消</span>
        </h3>
      </div>
    </el-dialog>
    <el-dialog class="merchandiserDialog chooseServiceCss" width="1000px" :title="Lib.collectively()+'列表'" :visible.sync="MerchandiserDialog" :append-to-body="true">
      <div class="el-message-box__content" style="height: 586px;padding: 0;">
        <div class="dialog_header">
          <el-input v-model="searchMerchandiserVal" class="width_242" placeholder="请输入员工姓名/工号" style="float:left;" @keyup.enter.native="searchMerchandiser">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="searchMerchandiser"></i>
          </el-input>
          <p>服务项目：{{ dialogServiceName }}</p>
          <h6>
            <span>价格：</span>
            <label>￥{{ dialogServiceTotal }}</label>
          </h6>
        </div>
        <div class="commonTable tablePointer" style="height: 528px;border: 1px solid #eee;width: 280px;float: left;overflow: hidden;">
          <el-tabs v-if="brandInfo.cardOpen == 1" v-model="activeName" class="brandList" @tab-click="getStaffData">
            <el-tab-pane v-for="(v,n) in brandInfo.cards" :key="n" :label="v.cardName" :name="v.id+''">
              <span v-if="v.cardName == '未分配'" slot="label">{{ v.cardName }}
                <el-tooltip class="item" effect="light" :content="'展示后台未分配轮牌的'+Lib.collectively()" placement="right">
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </span>
            </el-tab-pane>
          </el-tabs>
          <el-table ref="searchMerchandiserTable" tooltip-effect="light" :data="searchMerchandiserList" class="newSelect" height="530" @select="selectMerchandiser" @row-click="rowClickMerchandiser">
            <el-table-column :class-name="'ht_23'" type="selection" width="55"></el-table-column>
            <el-table-column label="工号" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.number || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="technicianName" label="姓名" :show-overflow-tooltip="true"></el-table-column>
          </el-table>
        </div>
        <div class="commonTable" style="height: 528px;border: 1px solid #eee;width: 630px;float: right;">
          <el-table tooltip-effect="light" class="merchandiserTable" :data="chooseMerchandiserList" height="530">
            <el-table-column label="员工" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.number }}/{{ scope.row.technicianName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="点客">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.isGuest" :true-label="0" :false-label="1" @change="changeCheckboxList(scope.$index,scope.row)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="提成点">
              <template slot-scope="scope">
                <el-input v-model="scope.row.percentage" size="mini" style="width: 100px;" :disabled="Lib.getPercentage()" placeholder @change="changeCheckboxList">
                  <template slot="append">{{ scope.row.percentageType === 1?'元':'%' }}</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="操作" width="80">
              <template slot-scope="scope">
                <yz-btn type="delete" @click="delChooseTechnician(scope.row.technicianId)">删除</yz-btn>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="newFootCss">
        <div class="newFootBtn">
          <el-button type="primary" @click="comfirmAddProject">确 定</el-button>
          <el-button @click="MerchandiserDialog = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="memberDialog" title="会员充值" :visible.sync="memberDialog" :append-to-body="true">
      <iframe :src="memberManageSrc"></iframe>
    </el-dialog>

    <Autograph ref="child" @getCanvas="getCanvasUrl"></Autograph>
  </div>
</template>
<script>
import {
  saveClientPackagePastTime, // 6.1-修改套餐到期时间
  getPercentageSkin, // （4.5.0）获取全局提成设置
  postDeductCardCount, // 确定划扣保存
  printOrder, // 打印接口
  getPrintSetList, // 打印机列表
  erpTechnicianCardByMainId, // 5.7erp选择统称，选择销售的轮牌列表
  getStaffBrandList, // 5.7（服务开单或修改订单）根据项目、产品、套餐id获取统称-员工列表
  getMemberUrl
} from '../../api';

export default {
  props: {
    show: {
      type: Boolean,
      default: Boolean
    },
    detailsData: {
      type: Object,
      default: Object
    },
    detailsLoading: {
      type: Boolean,
      default: Boolean
    },
    searchBeforePhone: {
      type: String,
      default: String
    },
    memberInfo: {
      type: Object,
      default: Object
    },
    status: {
      type: Number,
      default: Number
    },
    openListy: {
      type: Function,
      default: null,
    },
    phoneSearch: {
      type: Function,
      default: null,
    },
    getDeductList: {
      type: Function,
      default: null,
    },
    editCardListShow: {
      type: Function,
      default: null,
    },
    recharge: {
      type: Function,
      default: null,
    }
  },
  data() {
    return {
      isDesktop: this.$isDesktop() === true ? 1 : 0, // 判断是否是客户端 0不是  1是-5.7添加
      ishd: window.sessionStorage.ishd ? 1 : 0, // 判断是否是HD  0不是  1是-5.7添加
      chooseBuckleProject: [], // 选择的划扣项目
      buckleBtn: false, // 划扣按钮
      buckleDiglog: false, // 划扣弹出框
      chooseId: '', // 选择的划扣ID
      printerList: [], // 打印机列表
      printerId: '', // 打印机ID
      printerName: '', // 打印机名称
      refreshStatus: false, // 刷新状态
      chooseServiceList: [], // 选择要划扣的服务列表
      chooseProductList: [], // 选择要划扣的产品列表

      scaleStan: 0, // 全局提成  0为原价算提成   1为折后价算提成
      chooseServiceIndex: '',
      MerchandiserDialog: false, // 选择开单员弹出窗口
      dialogServiceName: '', // 弹出框选择的服务项目名称
      dialogServiceTotal: 0, // 弹出框选择的服务总价
      dialogServicePreTotal: 0, // 弹出框选择的服务原价
      chooseItemId: '', // 选择的项目ID
      searchMerchandiserVal: '', // 搜索开单员
      searchMerchandiserList: [], // 搜索开单员列表
      chooseMerchandiserList: [], // 选择开单员列表
      percentageTotal: '0', // 提成总价

      chooseListIndex: '',
      serviceNum: 0, // 通用-总项目次数
      productNum: 0, // 通用-总项目次数
      NumOf: null, // 通用判断次数是否禁用
      // 5.7
      brandInfo: {},
      activeName: '',
      // 6.1
      dueDate: '', // 到期时间
      // 6.7
      orderSignature: '',

      diaTabs: 'first',
      openListKey: [], // 打开列表的key值
      tooltipStatus: false, // 气泡显示

      // 6.81
      memberManageSrc: '',
      memberDialog: false,
    };
  },
  watch: {
    show(val) {
      if (val == false) {
        this.chooseServiceList = [];
        this.chooseProductList = [];
      }
    }
  },
  activated() {
    this.openListKey = [];
  },
  methods: {
    getChooseHkInfo() {
      console.log(this.chooseServiceList, this.chooseProductList);
      let text = '';
      if (this.chooseServiceList.length > 0) {
        text = `已选项目${this.chooseServiceList.length}，`;
      }
      if (this.chooseProductList.length > 0) {
        text = `已选产品${this.chooseProductList.length}，`;
      }
      if (this.chooseServiceList.length > 0 || this.chooseProductList.length > 0) {
        let total = 0;
        this.chooseServiceList.forEach((a) => {
          total += a.count * 1;
        });
        this.chooseProductList.forEach((a) => {
          total += a.count * 1;
        });
        text = `${text}划扣次数${total}`;
      }
      return text;
    },
    // 会员充值
    newGetMemberUrl(val) {
      if (val == 1) {
        if (this.Lib.checkPower('beauty-2-czhy') == false) return;
      }
      const data = { type: val };
      getMemberUrl(data).then((res) => {
        if (res.code == 0) {
          this.memberManageSrc = `${res.data}?phone=${this.memberInfo.phone}&hideBack=1&shopId=${window.sessionStorage.shopId}`;
          this.memberDialog = true;
        } else {
          console.log(res);
        // this.$message(res.msg)
        }
      });
    },
    // 6.7
    getCanvasUrl(val) {
      const vm = this;
      vm.orderSignature = val;
      vm.submitBuckle();
    },
    // 修改到期时间
    modifyDueTiem(type, data) {
      if (type === 0) {
        this.dueDate = data.pastTime;
      } else if (type === 1) {
        const params = {
          mainId: window.sessionStorage.mainId,
          clientVipCardId: data.clientVipCardId,
          pastTime: this.dueDate,
        };
        $('.el-dialog').click();
        saveClientPackagePastTime(params).then((res) => {
          if (res.code === 0) {
            this.pageNum = 1;
            this.$message({
              message: '修改成功',
              type: 'success'
            });
          }
          this.openListy(data.id, data.clientVipCardId);
          this.getDeductList();
        });
      }
    },
    // 划扣勾选事件
    projectSelectionChange(item, selection, status) {
      if (status == 1) {
        if (selection.length == 0) {
          for (let i = 0; i < item.length; i++) {
            item[i].chooseList = item[i].chooseList.splice(0, 1);
            item[i].count = 1;
          }
        }
        this.openListKey = [];
        this.chooseServiceList = [];
        item.forEach((a) => {
          a.isDisabled = 0;
        });
        selection.forEach((b) => {
          b.isDisabled = 1;
          b.chooseList.forEach((c) => {
            c.isDisabled = 1;
          });
          this.openListKey.push(b.id);
        });
        this.chooseServiceList = selection;
      } else {
        if (selection.length == 0) {
          for (let i = 0; i < item.length; i++) {
            item[i].count = 1;
          }
        }
        this.chooseProductList = [];
        item.forEach((a) => {
          a.isDisabled = 0;
        });
        selection.forEach((b) => {
          b.isDisabled = 1;
        });
        this.chooseProductList = selection;
      }
      this.getReckon(status);
    },
    // 判断table  Selection是否可勾选
    checkTableSelectionOne(row) {
      if (this.detailsData.countLimitType == 2 && this.detailsData.type != 4 && row.status != -1 && row.status != -2) {
        return true; // 不禁用
      }
      if (row.residueCount < 1 || row.status == -1 || row.status == -2
          || (this.detailsData.countLimitType == 3 && this.detailsData.beUsedCount == 0) || this.detailsData.type == 4) {
        return false; // 禁用
      }
      return true; // 不禁用
    },
    // 选择项目提成员工--弹出窗口
    chooseStaff(n, val) {
      getPercentageSkin({ mainId: window.sessionStorage.mainId }).then((res) => {
        this.scaleStan = res.data.scaleStan;
      });
      this.chooseServiceIndex = n;
      this.chooseListIndex = val;
      this.MerchandiserDialog = true;
      this.dialogServiceName = this.detailsData.clientVipCardItemInfoList[n].dictItemName;
      this.dialogServiceTotal = this.detailsData.clientVipCardItemInfoList[n].vipCardItemPrice.toFixed(2);
      this.dialogServicePreTotal = this.detailsData.clientVipCardItemInfoList[n].vipCardItemPrice.toFixed(2);
      this.chooseItemId = this.detailsData.clientVipCardItemInfoList[n].itemId;
      const files = this.detailsData.clientVipCardItemInfoList[n].chooseList[val].percentage4ServeList;
      const arr = [];
      if (files.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          arr.push(item);
        }
      }
      this.chooseMerchandiserList = arr;
      this.changeCheckboxList();
      if (this.Lib.checkPower('beauty-1-lp', 2)) {
        this.newGetBrandList(1, 1);
      } else {
        this.getStaffData();
      }
    },
    countChange(row, index, type) {
      if (row) {
        const num = Math.floor(this.detailsData.clientVipCardItemInfoList[index].chooseList.length * 1 - row.count * 1);
        const numTwo = Math.floor(row.count * 1 - this.detailsData.clientVipCardItemInfoList[index].chooseList.length * 1);
        let data = {};
        if (num >= 0) {
          // eslint-disable-next-line vue/no-mutating-props
          this.detailsData.clientVipCardItemInfoList[index].chooseList.splice(0, num);
        } else {
          for (let i = 0; numTwo > i; i++) {
            data = this.detailsData.clientVipCardItemInfoList[index];
            data.chooseList.unshift({
              dictItemName: data.dictItemName,
              isDisabled: data.isDisabled,
              percentage4ServeList: data.percentage4ServeList,
              isPercentage: data.isPercentage,
              residueCount: data.residueCount,
              itemId: data.itemId
            });
          }
        }
      }
      this.getReckon(type);
      this.getChooseHkInfo();
    },
    // 判断table  Selection是否可勾选
    checkTableSelectionTwo(row) {
      if (row.isDeduct == 1) {
        if (row.residueCount < 1) {
          return false; // 禁用
        }
        return true; // 不禁用
      }
      return false; // 不禁用
    },
    // 确定划扣
    submitBuckle() {
      const serviceArr = [];
      this.chooseServiceList.forEach((a) => {
        a.chooseList.forEach((n) => {
          const obj = {};
          obj.clientVipCardItemId = a.clientVipCardItemId;
          obj.dictItemId = a.dictItemId;
          obj.dictItemName = a.dictItemName;
          obj.dictTypeName = a.dictTypeName;
          obj.disabled = false;
          obj.expenseCount = 1;
          obj.id = a.id;
          obj.imgUrl = a.imgUrl;
          obj.isPercentage = a.isPercentage;
          obj.itemId = a.itemId;
          const itemFiles = n.percentage4ServeList;
          const itemArr = [];
          itemFiles.forEach((d) => {
            const objLi = {};
            objLi.isGuest = d.isGuest;
            objLi.isMember = this.memberInfo.cardNo ? 1 : 0;
            objLi.setType = d.endNum ? 1 : d.item4ServeList ? (d.item4ServeList[0].setType ? 1 : 0) : 0;
            const newStatus = this.memberInfo.cardNo && d.isGuest == 1 ? d.isMemberNotGuest : this.memberInfo.cardNo && d.isGuest == 0 ? d.isMemberGuest : !this.memberInfo.cardNo && d.isGuest == 1 ? d.isVisitorNotGuest : d.isVisitorGuest;
            const isUpdate = d.item4ServeList ? (d.item4ServeList[0].isUpdate == 0 ? d.percentage : newStatus) : newStatus;
            objLi.item4ServeList = [
              {
                isUpdate: isUpdate == d.percentage ? 0 : 1,
                percentageId: d.percentageId,
                percentageType: d.percentageType,
                price: d.percentage,
                // resultDiscountPrice: (a.vipCardItemPrice * d.percentage / 100).toFixed(2),
                // resultPrice: (a.vipCardItemPrice * d.percentage / 100).toFixed(2)
              }
            ];
            objLi.technicianId = d.technicianId;
            itemArr.push(objLi);
          });
          obj.percentage4ServeList = itemArr;
          obj.residueCount = a.residueCount;
          obj.vipCardItemPrice = a.vipCardItemPrice;
          serviceArr.push(obj);
        });
      });
      const productArr = [];
      this.chooseProductList.forEach((b) => {
        const obj = {};
        obj.disabled = false;
        obj.expenseCount = b.count;
        obj.id = b.id;
        const itemFiles = b.percentage4ProductList;
        const itemArr = [];
        itemFiles.forEach((c) => {
          const objLi = {};
          objLi.isGuest = c.isGuest;
          objLi.isMember = this.memberInfo.cardNo ? 1 : 0;
          objLi.percentageNumber = c.percentage;
          objLi.percentageType = c.percentageType;
          objLi.setType = c.levelType;
          objLi.technicianId = c.technicianId;
          itemArr.push(objLi);
        });
        obj.percentage4ProductList = itemArr;
        obj.productId = b.productId;
        obj.productTotal = (b.productPrice * b.count).toFixed(2);
        obj.residueCount = b.residueCount;
        productArr.push(obj);
      });
      this.buckleBtn = true;
      const data = {
        buySource: 0,
        clientVipCardId: this.chooseId,
        mainId: window.sessionStorage.mainId,
        phone: this.phoneSearchVal,
        clientVipCardItemInfoList: serviceArr,
        clientVipCardProductList: productArr,
        isElectronicTicketDeduct: this.detailsData.isElectronicTicket || 0,
        deductType: this.detailsData.isItemTicket || 0,
        orderSignature: this.orderSignature,
      };
      postDeductCardCount(data).then((res) => {
        if (res.code == 0) {
          this.printOrderId = res.data.orderId;
          // this.getPrinterList();
          // this.buckleDiglog = true;
          this.chooseBuckleProject = [];
          this.pageNum = 1;
          if (this.diaTabs == 'first') {
            this.phoneSearch(this.pageNum);
          } else {
            this.getDeductList();
          }
          window.sessionStorage.printOrderStatus = 1;
          this.$router.push({
            name: 'stage-settlementSuccess'
          });
          window.sessionStorage.successOrderId = res.data.orderId;
          window.sessionStorage.successResulteMoney = 0;
          window.sessionStorage.successOrderType = 4;
        } else {
          // this.$message(res.message);
        }
        this.buckleBtn = false;
        this.editCardListShow(false);
      });
    },
    // 会员套餐划扣
    buckle(item) {
      console.log(item);
      this.chooseId = item.clientVipCardId;
      const serviceData = this.chooseServiceList;
      const productData = this.chooseProductList;
      if (serviceData.length == 0 && productData.length == 0) {
        this.$message('请选择划扣项目');
        return;
      }
      if (item.countLimitType == 1) {
        if (serviceData.length > 0) {
          for (let i = 0; serviceData.length > i; i++) {
            if (serviceData[i].count == 0) {
              this.$message('项目划扣数量不能为0');
              return;
            } if (serviceData[i].count > serviceData[i].residueCount) {
              this.$message('项目划扣数量不能大于剩余次数');
              return;
            } if (!/(^[1-9]\d*$)/.test(serviceData[i].count)) {
              this.$message('项目划扣数量要为正整数');
              return;
            }
          }
        }
        if (productData.length > 0) {
          for (let j = 0; productData.length > j; j++) {
            if (productData[j].count == 0) {
              this.$message('产品划扣数量不能为0');
              return;
            } if (productData[j].count > productData[j].residueCount) {
              this.$message('产品划扣数量不能大于剩余次数');
              return;
            } if (!/(^[1-9]\d*$)/.test(productData[j].count)) {
              this.$message('产品划扣数量要为正整数');
              return;
            }
          }
        }
      }
      if (item.validType != 2) {
        const now = new Date().getTime();
        const endTime = new Date(item.pastTime).getTime() * 1 + 86400000;
        if (!(now < endTime)) {
          this.$message('请在该套餐有效时间内划扣');
          return;
        }
      }
      if (window.sessionStorage.isAutograph == 1) {
        this.$refs.child.show = true;
        return;
      }
      this.submitBuckle();
    },
    // 前往后台设置打印机
    jumpSetPrinter() {
      window.open(window.sessionStorage.setUrl4Print);
    },
    // 选择打印机
    choosePrinter(val) {
      this.printerId = val.split(',')[0];
      this.printerName = val.split(',')[1];
    },
    // 获取打印机列表
    getPrinterList() {
      this.refreshStatus = true;
      const data = {
        printType: 30
      };
      getPrintSetList(data).then((res) => {
        if (res && res.code == 0) {
          this.refreshStatus = false;
          this.printerList = res.data;
          let pNum = 'null';
          if (res.data.length > 0) {
            res.data.forEach((v, n) => {
              if (v.printerState == 1) {
                pNum = pNum == 'null' ? n : n > pNum ? pNum : n;
              }
            });
            if (pNum == 'null') {
              this.printerId = '';
              this.printerName = '暂无可用设备';
            } else {
              this.printerId = res.data[pNum].id;
              this.printerName = res.data[pNum].printerName;
            }
          }
          if (this.printerId) {
            this.printOrder();// 自动打印小票-5.7
          }
        } else {
          this.refreshStatus = true;
        }
      });
    },
    // 打印
    printOrder(num) {
      const data = {
        orderId: this.printOrderId,
        mainId: window.sessionStorage.mainId,
        printType: 4, // 1：服务订单，2:快捷收银订单，3：美容套餐购买/充值，4：美容套餐划扣
        printId: this.printerId,
        isManual: num ? 1 : 0
      };
      printOrder(data).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: 2000
          });
        }
      });
    },
    // 通用-项目+产品之和
    getReckon(status) {
      if (this.detailsData.countLimitType == 3) {
        this.serviceNum = 0;
        this.productNum = 0;
        if (this.chooseServiceList.length > 0) {
          this.chooseServiceList.forEach((item) => {
            this.serviceNum += item.count * 1;
          });
        }
        if (this.chooseProductList.length > 0) {
          this.chooseProductList.forEach((item) => {
            this.productNum += item.count * 1;
          });
        }
        this.NumOf = (this.serviceNum + this.productNum);
        if (status == 1) {
          if ((this.serviceNum + this.productNum) > this.detailsData.beUsedCount) {
            this.chooseServiceList = [];
            this.$message('已超过套餐剩余的通用次数，请确认划扣数量');
            this.$refs.multipleTableI.clearSelection();
          }
        } else if (status == 2) {
          if ((this.serviceNum + this.productNum) > this.detailsData.beUsedCount) {
            this.chooseProductList = [];
            this.$message('已超过套餐剩余的通用次数，请确认划扣数量');
            this.$refs.multipleTableP.clearSelection();
          }
        } else if (status == 3) {
          if ((this.serviceNum + this.productNum) > (this.detailsData.beUsedCount)) {
            this.$message('已超过套餐剩余的通用次数，请确认划扣数量');
          }
        }
      }
    },
    newGetBrandList() {
      const data = {
        mainId: window.sessionStorage.mainId,
        cardType: 1,
        itemId: this.chooseItemId,
      };
      erpTechnicianCardByMainId(data).then((res) => {
        if (res.code == 0) {
          this.brandInfo = res.data;
          this.activeName = `${res.data.cards[0].id}`;
          this.getStaffData();
        } else {
          console.log(res);
        }
      });
    },
    // 搜索服务项目开单员列表
    searchMerchandiser() {
      this.Lib.keyboardBlur();
      this.getStaffData();
    },
    // 获得服务项目开单员列表
    getStaffData(val) {
      if (val) {
        this.pageNum = val;
      }
      const data = {
        itemId: this.chooseItemId,
        pageNo: 1,
        keyWord: this.searchMerchandiserVal,
        pageSize: 999999,
        mainId: window.sessionStorage.mainId,
        isDeduct: 1, // 5.6新加
        cardId: this.brandInfo.cardOpen == 1 ? this.activeName : '', // 5.7新加  轮牌主键id
        type: 1, // 5.7新加 1：项目（选择统称） 2：项目（选择销售） 3：产品（选择销售） 4：套餐（选择销售）
      };
      getStaffBrandList(data).then((res) => {
        if (res.code == 0) {
          let allSearchMerchandiserList = [];
          if (res.data == null) {
            this.searchMerchandiserList = [];
          } else {
            this.searchMerchandiserList = res.data.lookItemPercentages;
            allSearchMerchandiserList = res.data.lookAllItemPercentages;
          }
          const newList = [];
          if (this.chooseMerchandiserList.length > 0) {
            for (let i = 0; this.chooseMerchandiserList.length > i; i++) {
              for (let j = 0; this.searchMerchandiserList.length > j; j++) {
                if (this.chooseMerchandiserList[i].technicianId == this.searchMerchandiserList[j].technicianId) {
                  this.chooseSelection(this.searchMerchandiserList[j], 1, true);
                }
              }
            }
          }
          if (this.chooseMerchandiserList.length > 0) {
            for (let i = 0; this.chooseMerchandiserList.length > i; i++) {
              for (let j = 0; allSearchMerchandiserList.length > j; j++) {
                if (this.chooseMerchandiserList[i].technicianId == allSearchMerchandiserList[j].technicianId) {
                  const item = this.chooseMerchandiserList[i];
                  const sitem = allSearchMerchandiserList[j];
                  const obj = {};
                  obj.isGuest = item.isGuest;
                  obj.endNum = sitem.endNum;
                  obj.percentage = item.percentage;
                  obj.number = sitem.number;
                  obj.levelType = sitem.levelType;
                  obj.technicianId = sitem.technicianId;
                  obj.percentageId = sitem.id;
                  obj.technicianName = sitem.technicianName;
                  obj.isMemberGuest = sitem.isMemberGuest;
                  obj.isMemberNotGuest = sitem.isMemberNotGuest;
                  obj.isVisitorGuest = sitem.isVisitorGuest;
                  obj.isVisitorNotGuest = sitem.isVisitorNotGuest;
                  obj.percentageType = sitem.percentageType;
                  newList.push(obj);
                }
              }
            }
            this.chooseMerchandiserList = newList;
            this.changeCheckboxList();
          }
        }
      });
    },
    // 计算提成总价
    changeCheckboxList(index, row) {
      const vm = this;
      let percentagePrice = 0;
      if (vm.chooseMerchandiserList) {
        if (row) {
          vm.chooseMerchandiserList[index].percentage = vm.memberInfo.cardNo && vm.chooseMerchandiserList[index].isGuest == 1 ? row.isMemberNotGuest : vm.memberInfo.cardNo && vm.chooseMerchandiserList[index].isGuest == 0 ? row.isMemberGuest : !vm.memberInfo.cardNo && vm.chooseMerchandiserList[index].isGuest == 1 ? row.isVisitorNotGuest : row.isVisitorGuest;
        }
        if (vm.chooseMerchandiserList.length > 0) {
          vm.chooseMerchandiserList.forEach((v) => {
            const newVal = v.percentageType == 1 ? (v.percentage * vm.detailsData.clientVipCardItemInfoList[vm.chooseServiceIndex].count).toFixed(2) : vm.scaleStan == 1 ? (v.percentage * vm.dialogServiceTotal) / 100 : (v.percentage * vm.dialogServicePreTotal) / 100;
            percentagePrice += newVal * 1;
          });
          vm.percentageTotal = (percentagePrice * 1).toFixed(2);
        } else {
          vm.percentageTotal = 0;
        }
      } else {
        vm.percentageTotal = 0;
      }
    },
    // 选择开单员--勾选事件
    selectMerchandiser(selection, row) {
      const vm = this;
      const obj = {};
      obj.endNum = row.endNum;
      obj.number = row.number;
      obj.technicianId = row.technicianId;
      obj.percentageId = row.id;
      obj.technicianName = row.technicianName;
      obj.isGuest = 1;
      obj.percentage = this.memberInfo.cardNo ? row.isMemberNotGuest : row.isVisitorNotGuest;
      obj.startNum = row.startNum;
      obj.endNum = row.endNum;
      obj.isDelete = row.isDelete;
      obj.isMemberGuest = row.isMemberGuest;
      obj.isMemberNotGuest = row.isMemberNotGuest;
      obj.isVisitorGuest = row.isVisitorGuest;
      obj.isVisitorNotGuest = row.isVisitorNotGuest;
      obj.percentageType = row.percentageType;
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.chooseMerchandiserList.length > j; j++) {
        if (vm.chooseMerchandiserList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.chooseMerchandiserList.length) {
        vm.chooseMerchandiserList.push(obj);
        vm.chooseSelection(obj);
      } else {
        vm.chooseMerchandiserList.splice(index, 1);
        vm.delSelection(obj);
      }
      setTimeout(() => {
        vm.changeCheckboxList();
      }, 100);
    },
    // 选择开单员--勾选事件
    rowClickMerchandiser(row) {
      const vm = this;
      const obj = {};
      obj.endNum = row.endNum;
      obj.number = row.number;
      obj.technicianId = row.technicianId;
      obj.percentageId = row.id;
      obj.technicianName = row.technicianName;
      obj.isGuest = 1;
      obj.percentage = this.memberInfo.cardNo ? row.isMemberNotGuest : row.isVisitorNotGuest;
      obj.startNum = row.startNum;
      obj.endNum = row.endNum;
      obj.isDelete = row.isDelete;
      obj.isMemberGuest = row.isMemberGuest;
      obj.isMemberNotGuest = row.isMemberNotGuest;
      obj.isVisitorGuest = row.isVisitorGuest;
      obj.isVisitorNotGuest = row.isVisitorNotGuest;
      obj.percentageType = row.percentageType;
      vm.$refs.searchMerchandiserTable.toggleRowSelection(row);
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.chooseMerchandiserList.length > j; j++) {
        if (vm.chooseMerchandiserList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.chooseMerchandiserList.length) {
        vm.chooseMerchandiserList.push(obj);
        setTimeout(() => {
          vm.changeCheckboxList();
        }, 100);
      } else {
        vm.chooseMerchandiserList.splice(index, 1);
        setTimeout(() => {
          vm.changeCheckboxList();
        }, 100);
      }
    },
    // 确定添加提成员工
    comfirmAddProject() {
      const files = this.chooseMerchandiserList;
      const arr = [];
      if (this.chooseMerchandiserList.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          arr.push(item);
        }
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.detailsData.clientVipCardItemInfoList[this.chooseServiceIndex].chooseList[this.chooseListIndex].percentage4ServeList = arr;
      this.MerchandiserDialog = false;
    },
    // 删除选择的提成统称
    delChooseTechnician(id) {
      const vm = this;
      for (let i = 0; vm.searchMerchandiserList.length > i; i++) {
        if (vm.searchMerchandiserList[i].technicianId == id) {
          vm.delSelection(vm.searchMerchandiserList[i]);
        }
      }
      for (let j = 0; vm.chooseMerchandiserList.length > j; j++) {
        if (vm.chooseMerchandiserList[j].technicianId == id) {
          vm.chooseMerchandiserList.splice(j, 1);
          setTimeout(() => {
            vm.changeCheckboxList();
          }, 100);
        }
      }
    },
    // 回选多选选择框
    chooseSelection(row) {
      const vm = this;
      setTimeout(() => {
        vm.$refs.searchMerchandiserTable.toggleRowSelection(row, true);
      }, 100);
    },
    // 回选多选选择框
    delSelection(row) {
      const vm = this;
      setTimeout(() => {
        vm.$refs.searchMerchandiserTable.toggleRowSelection(row, false);
      }, 100);
    },
    // 时间比较--续费
    timeRemindX(type, validType, endTime, status) {
      if (type != 1 && status == 0) {
        if (validType == 1) {
          const str = endTime.replace('-', '/');
          const oldTime = new Date(str).getTime() * 1 + 86400000;
          if (new Date().getTime() > oldTime) {
            return false;
          }
          return true;
        }
        return true;
      }
      return false;
    },
    // 到期时间限制
    disabledDate(date) {
      return date.getTime() < new Date(this.detailsData.startTime).getTime();
      // return date.getTime() > new Date(this.detailsData.pastTime).getTime();
    },
    seeOrder(v) {
      if (v.mainId != window.sessionStorage.mainId) {
        this.$message('请到对应门店查看详情');
        return;
      }
      window.sessionStorage.orderData = window.JSON.stringify(v);
      this.$router.push({
        name: 'stage-orderDeatilsData',
        params: {
          orderId: v.orderId,
          orderType: v.orderType
        }
      });
    },
  }
};
</script>
<style scoped lang="less">
.infoTop {
  display: flex;
  padding: 0 0 20px 0;
  .itLeft {
    width: 70px;
    height: 70px;
    float: left;
    margin-right: 20px;
    .liOne_img {
      width: 100%;
      height: 100%;
      box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.05);
    }
  }
  .itRight {
    flex: 1;
    p {
      color: #999;
      font-size: 14px;
      height: 35px;
      line-height: 35px;
      samp {
        color: #ccc;
        cursor: pointer;
      }
      span {
        padding-left: 20px;
        color: #09d8fd;
      }
      label {
        color: #09d8fd;
      }
    }
  }
}
/*套餐详情*/
.beauty_setmeal_details {
  .top {
    width: 100%;
    height: 100%;
    display: flex;
    text-align: left;
    margin-bottom: 10px;
    .details_img {
      border-radius: 6px;
      width: 200px;
      height: 200px;
      margin-right: 20px;
    }
    .detail_right {
      width: 714px;
      font-size: 14px;
      line-height: 22px;
      color: #303133;
      position: relative;
      p {
        padding-bottom: 10px;
      }
      p :last-child {
        padding-bottom: 0 !important;
      }
      .details_but {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
  .dialog-number {
    float: left;
    margin-top: 20px;
    font-size: 14px;
    color: #606266;
  }
}
.tableExpandList {
  background-color: #f6f6f6;
  list-style: none;
  .li {
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid #e6ebf5;
    .tableExpand {
      float: left;
      padding-left: 85px;
      width: 335px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .btnChoose {
      white-space: nowrap;
      width: 475px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      height: 48px;
    }
  }
  .li:last-child {
    border-bottom: 0;
  }
}
.newPackageDia {
  .info {
    height: auto;
    display: block;
    margin: auto;
    h1 {
      height: 90px;
      line-height: 90px;
      text-align: center;
      i {
        font-size: 90px;
        color: #67c23a;
      }
    }
    p {
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      text-align: center;
    }
    h6 {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #999;
      text-align: center;
      padding-bottom: 15px;
    }
    h5 {
      text-align: center;
    }
    h4 {
      text-align: center;
      margin: 20px auto;
      span {
        display: block;
        margin: 0 auto;
        width: 250px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #333;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #d8dce5;
        cursor: pointer;
      }
    }
    h3 {
      text-align: center;
      margin: 20px auto;
      span {
        display: block;
        margin: 0 auto;
        width: 250px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #fff;
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
}
.newFootCss {
  padding: 15px 0 20px 0;
  .newFootCode {
    float: right;
    margin-top: 10px;
    .newPrice {
      color: #666;
      font-size: 14px;
      padding: 10px 0 10px 35px;
      small {
        color: #ff2233;
        font-size: 16px;
      }
    }
  }
  .newFootBtn {
    float: right;
    display: block;
    width: 100%;
    text-align: right;
    padding-top: 7px;
  }
}
/*原来样式*/
.dialog_header {
  height: 48px;
  clear: both;
  p {
    line-height: 40px;
    height: 40px;
    margin-left: 27px;
    color: #666;
    font-size: 14px;
    width: 330px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    float: left;
  }
  h6 {
    line-height: 40px;
    height: 40px;
    color: #666;
    font-size: 14px;
    width: 330px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    float: right;
    text-align: right;
    label {
      color: #f56c6c;
      font-size: 18px;
    }
    samp {
      margin-left: 9px;
      text-decoration: line-through;
      font-size: 13px;
    }
  }
}
</style>
<style>
.beauty_setmeal_details .details_content .details_top {
  width: 100%;
  height: 19px;
  font-size: 14px;
  line-height: 25px;
  color: #999999;
  display: flex;
  align-items: center;
  margin: 17px 0;
}
.beauty_setmeal_details .details_content .details_top span {
  width: 3px;
  height: 14px;
  line-height: 19px;
  border-radius: 2px;
  display: inline-flex;
  margin-right: 15px;
}
.deduction .el-table__expand-icon {
  display: none;
}
.deduction .el-table__expanded-cell {
  padding: 0 !important;
}
.merchandiserDialog
  .el-table__header-wrapper
  .el-table__header
  .el-checkbox
  .el-checkbox__input
  .el-checkbox__inner {
  display: none !important;
}
.chooseServiceCss .el-dialog__body {
  overflow-x: hidden;
  padding-bottom: 10px;
}
.chooseServiceCss .el-dialog__body {
  overflow-x: hidden;
  padding-bottom: 10px;
}
.tablePointer .el-table tr {
  cursor: pointer;
}
.tablePointer .brandList {
  position: absolute;
  background-color: #f5f7fa;
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  width: 280px;
  color: #999;
  font-weight: bold;
  z-index: 1;
  overflow: hidden;
}
.tablePointer .brandList .el-tabs__item {
  width: 106px;
  padding: 0 5px;
  height: 48px;
  line-height: 48px;
  text-align: center;
}
.tablePointer .brandList .el-tabs__nav-wrap::after {
  height: 1px;
}
.newSelect .el-radio__label {
  padding-left: 20px !important;
}
.merchandiserTable .el-table__body-wrapper .el-table__body td {
  padding: 10px 0 6px 0 !important;
}
.merchandiserTable .el-table__fixed-right .el-table__body td {
  padding: 10px 0 6px 0 !important;
}
.icon_wkc {
    width: 18px;
    height: 18px;
    background: rgb(244, 244, 245);
    border: 1px solid rgb(233, 233, 235);
    border-radius: 16px;
    display: block;
    float: left;
    text-align: center;
    color: #999;
    margin-right: 5px;
    line-height: 18px;
    font-size: 12px;
    margin-top: 2px;
    cursor: context-menu;
}
.icon_xj {
    width: 18px;
    height: 18px;
    background: #FDF6EC;
    border: 1px solid #FAECD8;
    border-radius: 16px;
    display: block;
    float: left;
    text-align: center;
    color: #E6A23C;
    margin-right: 5px;
    line-height: 18px;
    font-size: 12px;
    margin-top: 2px;
    cursor: context-menu;
}
.icon_sc {
    width: 18px;
    height: 18px;
    background: #ffe9ee;
    border: 1px solid #ffc2d0;
    border-radius: 16px;
    display: block;
    float: left;
    text-align: center;
    color: #fd5c8c;
    margin-right: 5px;
    line-height: 18px;
    font-size: 12px;
    margin-top: 2px;
    cursor: context-menu;
}
</style>
